import { render, staticRenderFns } from "./ZReportHeading.vue?vue&type=template&id=48775f50&"
import script from "./ZReportHeading.vue?vue&type=script&lang=js&"
export * from "./ZReportHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports